var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg30DayMoneyBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3435 11.6913V14.6862C13.3435 15.1409 13.5241 15.5769 13.8456 15.8984C14.1671 16.2199 14.6031 16.4005 15.0578 16.4005H15.9132C16.3679 16.4005 16.8039 16.2199 17.1254 15.8984C17.4469 15.5769 17.6275 15.1409 17.6275 14.6862V11.6913C17.6275 11.2367 17.4469 10.8006 17.1254 10.4792C16.8039 10.1577 16.3679 9.97705 15.9132 9.97705H15.0578C14.6031 9.97705 14.1671 10.1577 13.8456 10.4792C13.5241 10.8006 13.3435 11.2367 13.3435 11.6913Z",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70386 15.3291C6.81454 15.6425 7.01975 15.9139 7.29117 16.1058C7.5626 16.2977 7.88687 16.4007 8.21929 16.4005H9.29071C10.177 16.4005 10.897 15.6805 10.897 14.7942V14.5268C10.897 14.3158 10.8555 14.107 10.7747 13.9121C10.694 13.7172 10.5757 13.5401 10.4265 13.391C10.2774 13.2418 10.1003 13.1235 9.90541 13.0428C9.71053 12.962 9.50166 12.9205 9.29071 12.9205H8.75414H9.157C9.54755 12.9205 9.9221 12.7653 10.1983 12.4892C10.4744 12.213 10.6296 11.8385 10.6296 11.4479C10.6296 11.0574 10.4744 10.6828 10.1983 10.4066C9.9221 10.1305 9.54755 9.97534 9.157 9.97534H8.353C8.03261 9.97581 7.7211 10.0806 7.4656 10.274C7.21011 10.4673 7.02455 10.7386 6.937 11.0468",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73671 3.42847H12.1653C14.4526 3.42819 16.6688 4.22335 18.4341 5.67771C20.1995 7.13207 21.4041 9.15509 21.8416 11.4001C22.2791 13.6452 21.9223 15.9725 20.8322 17.9833C19.7421 19.9941 17.9867 21.5633 15.8667 22.4219C13.7467 23.2805 11.3941 23.3751 9.21194 22.6895C7.02982 22.004 5.15404 20.5809 3.90601 18.6641C2.65798 16.7473 2.11538 14.4561 2.37118 12.1832C2.62699 9.91027 3.66528 7.79704 5.30814 6.20561",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3085 0.857178L8.73706 3.42861L11.3085 6.00003",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30DayMoneyBack);
export default __webpack_public_path__ + "static/media/30-day-money-back.86c1042063c5346ac6fc43ee43365426.svg";
export { ForwardRef as ReactComponent };